module.exports = __webpack_public_path__ + "img/title.bbc11fb4.png";